import { useState, useCallback } from 'react';

// Based on schema enum DriverStopType
export const STOP_TYPES = [
  { value: 'STOCKING', label: 'STOCKING' },
  { value: 'CLEAROUT', label: 'CLEAROUT' },
  { value: 'CLEAROUT_DECOMMISSION', label: 'CLEAROUT_DECOMMISSION' },
];

const defaultFilters = (now) => ({
  dropOffDateFilter: now,
  regionFilter: { value: 'ALL', label: 'ALL' },
  routesFilter: [],
  fulfillmentCenterFilter: { value: 'ALL', label: 'ALL' },
  stopTypeFilter: [], // default to STOCKING
  retailerFilter: [],
});

export default function useStockingDashboardFilters(initialDate = new Date()) {
  const [filters, setFilters] = useState(defaultFilters(initialDate));

  const setFilter = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(defaultFilters(initialDate));
  }, [initialDate]);

  return {
    filters,
    setFilter,
    setFilters, // for bulk updates
    resetFilters,
    STOP_TYPES,
  };
}
